import { defineMessages } from 'react-intl';

const messages = defineMessages({
  // static strings
  yesString: {
    id: 'a5msuh',
    defaultMessage: 'Yes',
  },
  noString: {
    id: 'oUWADl',
    defaultMessage: 'No',
  },
  notSureString: {
    id: 'QyNWXw',
    defaultMessage: 'Not Sure',
  },
  daysString: {
    id: 'Bc20la',
    defaultMessage: 'days',
  },
  // steps content
  introTitle: {
    id: 'qBa/vJ',
    defaultMessage:
      'How resilient is your organization in the face of evolving cyberthreats?',
  },
  introCopy: {
    id: 'KePYGB',
    defaultMessage: `Today, the volume of data and diverse range of workloads make the journey towards data resilience more complex than ever. It requires a careful combination of hardware, software, strategic consulting and more, to minimize business impacts from cyberthreats. 
 
    This 10-question cyber resiliency assessment is a first step towards achieving end-to-end resilience for your organization. Let’s begin with identifying how prepared your organization is in the face of a cyberthreat. Then you can formulate a more comprehensive plan.`,
  },
  introCopyV2: {
    id: 'sZawwp',
    defaultMessage: `
    Take this 10-question cyber resilience assessment as your first step towards comprehensive organizational resilience against cyberthreats. Identifying how prepared your business is will allow you to formulate a more comprehensive plan.
    `,
  },
  introButton: {
    id: 'u1e2zt',
    defaultMessage: 'Take the assessment',
  },
  q1Title: {
    id: 'Ao5n3M',
    defaultMessage: `Have you identified the data that keeps your business running so you can protect it appropriately?`,
  },
  q2Title: {
    id: 'Fn3p22',
    defaultMessage: `Do you understand the overall cost of a cyberattack targeting the data in your industry?`,
  },
  q3Title: {
    id: '7kS74L',
    defaultMessage: `In the event of a cyberattack, is it possible for you to recover your critical business services by detecting and responding within minutes?`,
  },
  q4Title: {
    id: 'tvE3Wz',
    defaultMessage:
      'Do you have tightly integrated security and storage operations for an end-to-end response to cyberattacks?',
  },
  q4PopUpTitleV2: {
    id: 'Efh0It',
    defaultMessage: 'How can cyberattacks be mitigated with success?',
  },
  q4PopUpText: {
    id: 'd9j7jl',
    defaultMessage:
      'Start by identifying and safeguarding critical assets, detecting malware, and implementing automated responses.',
  },
  q4PopUpTitle: {
    id: 'IzeKtN',
    defaultMessage:
      'Mitigating cyberattacks successfully requires the following end-to-end response:',
  },
  q4PopUp1: {
    id: '+1i+B0',
    defaultMessage: 'Identify critical assets that keep your business running.',
  },
  q4PopUp2: {
    id: 'Bm22Yt',
    defaultMessage: 'Protect critical assets.',
  },
  q4PopUp3: {
    id: 'dfO1M0',
    defaultMessage: 'Detect malware.',
  },
  q4PopUp4: {
    id: 'CJ1LqX',
    defaultMessage: 'Respond with automation.',
  },
  q4PopUp5: {
    id: 'nKBwIf',
    defaultMessage: 'Enable rapid recovery.',
  },
  q5Title: {
    id: 'f+p+NH',
    defaultMessage:
      'Is your organization capable of swiftly detecting malware at the host, network and storage layer to minimize potential damage?',
  },
  q5PopUpTitleV2: {
    id: '6RmnK/',
    defaultMessage: 'How damaging can cyberthreats be?',
  },
  q5PopUpText: {
    id: 'T3iTw6',
    defaultMessage:
      'Cyberthreats can encrypt up to 2.4 PB of data in 24 hours.',
  },
  q5PopUp: {
    id: 'T3iTw6',
    defaultMessage:
      'Cyberthreats can encrypt up to 2.4 PB of data in 24 hours.',
  },
  q6Title: {
    id: 'eene2n',
    defaultMessage:
      'Did you know that zero-day attacks can introduce dormant malware into your system that may remain inactive for several weeks and even months?',
  },
  q6PopUpTitleV2: {
    id: 'jjyZQ5',
    defaultMessage: 'What’s a zero-day attack?',
  },
  q6PopUpText: {
    id: 'gSoD0D',
    defaultMessage:
      'A zero-day attack uses an unknown security flaw before it’s fixed, giving no time for defense.',
  },
  q6PopUp: {
    id: 'gSoD0D',
    defaultMessage:
      'A zero-day attack uses an unknown security flaw before it’s fixed, giving no time for defense.',
  },
  q7Title: {
    id: 'YP8FMC',
    defaultMessage:
      'Does your organization regularly scan data and applications to detect threat signatures, no matter where they reside?',
  },
  q7PopUp: {
    id: 'nBvmqt',
    defaultMessage:
      'Best practice for malware scanning is continual scanning of primary storage, backup data, network and applications',
  },
  q7PopUpTitleV2: {
    id: 'rpICgw',
    defaultMessage: 'Learn best practice for malware scanning',
  },
  q7PopUpText: {
    id: '8O5ln+',
    defaultMessage:
      'Best practice for malware scanning is continual scanning of primary storage, backup data, network and applications.',
  },
  q8Title: {
    id: 'aM3L1U',
    defaultMessage:
      'Did you know that although the industry average to recover from a cyberattack is 23 days, the new regulations—NIS2, DORA and others—mandate recovery of critical systems within hours?',
  },
  q8TitleV2: {
    id: 'Mv1Fgz',
    defaultMessage:
      'Did you know that although the industry average to recover from a cyberattack is 23 days, the new regulations—NIS2, DORA and others— mandate recovery of critical systems within hours?',
  },
  q8PopUpTitleV2: {
    id: '+AHucK',
    defaultMessage: 'What’s NIS2 and DORA?',
  },
  q8PopUpText: {
    id: 'TBkA0o',
    defaultMessage:
      'NIS2: Network and Information Security Directive DORA: Digital Operation Resilience Act',
  },
  q9Title: {
    id: 'Fx8Om4',
    defaultMessage:
      'In the event of a cyberattack do you know how long it would take to make your company operational again?',
  },
  q9PopUpTitleV2: {
    id: 'TDnkw0',
    defaultMessage: 'Is yours the one in seven companies?',
  },
  q9PopUpText: {
    id: 'srNw+n',
    defaultMessage:
      'Only one in seven companies can fully recover data from backups following a cyberattack.',
  },
  q9PopUp: {
    id: 'srNw+n',
    defaultMessage:
      'Only one in seven companies can fully recover data from backups following a cyberattack.',
  },
  q10Title: {
    id: 'VyJ4Qx',
    defaultMessage:
      'Is your company affected by the upcoming DORA regulations?',
  },
  // results data
  resultsTitleGreen: {
    id: 'faL2NL',
    defaultMessage: 'Excellent.',
  },
  resultsSubtitleGreen: {
    id: 'nIprJP',
    defaultMessage:
      'You have a good understanding of how to prepare for cyberattacks.',
  },
  resultsSubtitleGreenV2: {
    id: 'A6szlO',
    defaultMessage: 'You comprehend cyberattack readiness.',
  },
  resultsTitleYellow: {
    id: 'ibVEz+',
    defaultMessage: 'Nice, you’re almost there.',
  },
  resultsSubtitleYellow: {
    id: 'dXsUen',
    defaultMessage: 'It’s time to improve your cyber resiliency plan.',
  },
  resultsSubtitleYellowV2: {
    id: '+DKgoG',
    defaultMessage: 'It’s time to boost your cyber resiliency plan.',
  },
  resultsTitleRed: {
    id: 'KIPXxj',
    defaultMessage: 'You’re not quite there.',
  },
  resultsSubtitleRed: {
    id: '4JQ0+7',
    defaultMessage: `But don't panic. We can help.`,
  },
  resultsCopy: {
    id: '6G5xGA',
    defaultMessage:
      'Understanding your critical systems is an important first step towards building a cyber resiliency solution. Data security doesn’t come from a specific piece of hardware or software. It requires the right people, processes and technology on top of a rigorous adherence to operational principles to prevent cyberthreat impacts. Governments are enacting increasingly severe laws to ensure that companies’ data operations are properly protected.',
  },
  resultsCopyV2: {
    id: 'Rlrt/a',
    defaultMessage:
      'Knowing your critical systems is an important first step towards building a cyber resiliency solution.',
  },
  insightTitle: {
    id: 'wWeSpO',
    defaultMessage: 'Deepen your insight',
  },
  insightCopy: {
    id: 'WNukoK',
    defaultMessage:
      'We invite you to a 2-hour workshop for an in-depth assessment of your organization’s cyberattack preparedness at no cost.',
  },
  insightCta: {
    id: 'GKnYkz',
    defaultMessage: 'Sign up for the workshop',
  },
  whatDoYouGetTitle: {
    id: 'h4Te/7',
    defaultMessage: 'What do you get from the workshop?',
  },
  whatDoYouGetCopy: {
    id: '+fhcIu',
    defaultMessage: `After assessing your cyber resilience you’ll receive an executive summary
      categorized by priority, with recommended insights and actions.`,
  },
  whatDoYouGetPopUpTitle: {
    id: 'sf4IuP',
    defaultMessage: 'What benefits await you?',
  },
  whatDoYouGetPopUpText: {
    id: 'n4Bdux',
    defaultMessage:
      'A detailed evaluation will allow our experts to provide you with specific recommendations to increase the value of solutions and services, meet RTO/RPO requirements and help improve your posture against NIS2 and DORA, serving as a reliable starting point to prioritize initiatives.',
  },
  whatDoYouGetCta: {
    id: 'yBJ4Mv',
    defaultMessage: 'Explore sample report',
  },
  statsTitleV2: {
    id: 'F+8iwO',
    defaultMessage: 'Being safe means being ahead',
  },
  stats1V2: {
    id: 'Tpm2S+',
    defaultMessage: 'of data breaches accessed multiple environments.',
  },
  stats2V2: {
    id: '528mmb',
    defaultMessage: 'it’s the average to identify a data breach',
  },
  stats3V2: {
    id: 'ypVbTw',
    defaultMessage: 'of organizations could not recover all data.',
  },
  stats4V2: {
    id: 'pUCFBQ',
    defaultMessage: 'is how long it usually takes to contain an attack.',
  },
  nextStepTitle: {
    id: 'EMmCDl',
    defaultMessage: 'Take the next step',
  },
  nextStepCopy: {
    id: 'pSiFON',
    defaultMessage:
      'We invite you to a 2-hour cyber resilience workshop for an in-depth assessment of your organization’s cyberattack preparedness',
  },
  nextStepCopyBold: {
    id: 'bvDn+u',
    defaultMessage: 'at no cost to you',
  },
  nextStepCopy2: {
    id: 'gKpY3s',
    defaultMessage:
      'Together with our experts, we can create a detailed cyber resilience plan that’s specific to your business.',
  },
  nextStepCta: {
    id: 'GKnYkz',
    defaultMessage: 'Sign up for the workshop',
  },
  expertsTitle: {
    id: '09A5vW',
    defaultMessage: 'Why work with IBM experts?',
  },
  expertsCopy: {
    id: 'FoixIN',
    defaultMessage:
      'See the level of analysis that you can get from our full cyber resilience workshop.',
  },
  expertsCta: {
    id: 'yBJ4Mv',
    defaultMessage: 'Explore sample report',
  },
  statsTitle: {
    id: 'F+8iwO',
    defaultMessage: 'Being safe means being ahead',
  },
  stats1: {
    id: 'Tpm2S+',
    defaultMessage: 'of data breaches accessed multiple environments.',
  },
  stats2: {
    id: 'ypVbTw',
    defaultMessage: 'of organizations could not recover all data.',
  },
  stats3: {
    id: 'PjzuzF',
    defaultMessage: 'is the average time to identify a data breach.',
  },
  stats4: {
    id: 'pUCFBQ',
    defaultMessage: 'is how long it usually takes to contain an attack.',
  },
  statsCopy: {
    id: 'r8WvaA',
    defaultMessage:
      'Keep your organization protected from cyberthreats while also addressing new regulations.',
  },
  statsCta: {
    id: 'dPF4HR',
    defaultMessage: 'Join our workshop',
  },
  footnote1Link: {
    id: 'USqNIq',
    defaultMessage: 'Cost of a Data Breach Report 2023',
  },
  footnote1: {
    id: 'jp3Zyi',
    defaultMessage: ', IBM Security, July 2023.',
  },
  footnote2Link: {
    id: '2+cmDc',
    defaultMessage:
      'Research Report: Ransomware Preparedness: Lighting the Way to Readiness and Mitigation',
  },
  footnote2: {
    id: 'hYUNxC',
    defaultMessage: ', Enterprise Strategy Group, December 27, 2023.',
  },
});

export default messages;
